import { render, staticRenderFns } from "./AddMentor.vue?vue&type=template&id=c9c9b4c8&scoped=true"
import script from "./AddMentor.vue?vue&type=script&lang=js"
export * from "./AddMentor.vue?vue&type=script&lang=js"
import style0 from "./AddMentor.vue?vue&type=style&index=0&id=c9c9b4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c9b4c8",
  null
  
)

export default component.exports